import { Viewer } from '@photo-sphere-viewer/core';
import { GalleryPlugin } from '@photo-sphere-viewer/gallery-plugin';
window.PhotoSphereViewer = {
  Viewer,
  GalleryPlugin
};